"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensureDelay = ensureDelay;
exports.resolveAfter = resolveAfter;
exports.retryPromise = retryPromise;
function resolveAfter(delay, payload) {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(payload), delay);
  });
}
function ensureDelay(innerPromise, delay) {
  if (delay <= 0) return innerPromise;
  const delayed = resolveAfter(delay);
  return Promise.all([innerPromise, delayed]).then(_ref => {
    let [inner] = _ref;
    return inner;
  });
}
function retryPromise(promiseFactory, count) {
  return count <= 0 ? promiseFactory() : promiseFactory().catch(() => retryPromise(promiseFactory, count - 1));
}